module.exports = __webpack_public_path__ + "static/media/NatureIcon.d3840676.svg";